import React, { useContext } from 'react';
import { Avatar, Typography, Box, LinearProgress, Checkbox } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import StarIcon from '@material-ui/icons/Star';
import { I18nContext } from 'translations';
import { format } from 'date-fns';
import styles from './style';

const DriverReserved = ({ classes, selectedPrincipalBooking, data, bookingReservationId }) => {
  const { translate } = useContext(I18nContext);

  return (
    <Box className={classes.driverReservedCard}>
      <Box className={classes.driverInfoSection}>
        <Avatar 
          src={data?.driver?.photo_url ? data?.driver?.photo_url : "/images/users/default-avatar.png"} 
          className={classes.driverAvatar}
        />
        <Box className={classes.driverDetails}>
          <Typography className={classes.driverName}>
            {data?.driver?.name}
          </Typography>
          <Typography className={classes.plateText}>
            <strong>{translate('app.bookingReserved.plate')}:</strong> {data?.vehicle_plate ? data?.vehicle_plate : '-'}
          </Typography>
          <Typography className={classes.phoneText}>
            {data?.driver?.phone}
          </Typography>
          <Box className={classes.ratingContainer}>
            <StarIcon className={classes.starIcon} />
            <Typography className={classes.ratingText}>
              {data?.driver?.rating_as_driver}
            </Typography>
          </Box>
          <Typography className={classes.servicesText}>
            <b>{translate('app.bookingReserved.servicesText')}: </b>{data?.finished_services}
          </Typography>
        </Box>
        <Checkbox
          className={classes.driverCheckbox}
          color="primary"
          checked={bookingReservationId?._id === data?._id ? true : false}
          onChange={(e) => {
            if (bookingReservationId?._id === data?._id) {
              selectedPrincipalBooking(null);
            } else {
              selectedPrincipalBooking(data);
            }
          }}
        />
      </Box>

      <Box className={classes.timelineSection}>
        <Box className={classes.timelineLabels}>
          <Box className={classes.timeLabel}>
            <Typography className={classes.timeLabelText}>Inicio</Typography>
            <Typography className={classes.timeValue}>{data?.scheduled_at ? format(new Date(data?.scheduled_at), 'dd/MM/yyyy, hh:mm a') : '-'}</Typography>
          </Box>
          <LinearProgress 
            variant="determinate" 
            value={data?.consumed_percentage} 
            className={`${(data?.consumed_percentage > 50 && data?.consumed_percentage <= 75 ) ? classes.progressBarYellow : data?.consumed_percentage > 75 && data?.consumed_percentage <= 100 ? classes.progressBarRed : classes.progressBarGreen}`}
          />
          <Box className={classes.timeLabel}>
            <Typography className={classes.timeLabelText}>Fin</Typography>
            <Typography className={classes.timeValue}>{data?.finish_at ? format(new Date(data?.finish_at), 'dd/MM/yyyy, hh:mm a'): '-'}</Typography>
          </Box>
        </Box>
        <Typography className={classes.remainingTimeText}>
          {translate('app.bookingReserved.remainingTime')}: {data.remaining_time}
        </Typography>
      </Box>
    </Box>
  )
}

export default withStyles(styles)(DriverReserved);